module.exports = __webpack_public_path__ + "static/media/search-small-back.8fe0e8dc.svg";